import { IBookmakerDictionaryApi } from '@/types';

export class BookmakerDictionaryItem {
    code: string;
    id: number;
    isActive: 0 | 1;
    isVisibleForPlayer: 0 | 1;
    name: string;

    constructor(data: IBookmakerDictionaryApi) {
        this.id = data.id;
        this.name = data.name;
        this.code = data.code;
        this.isVisibleForPlayer = data.is_visible_for_player;
        this.isActive = data.is_active;
    }
}
